import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#288d2c',
    },
    secondary: {
        main: '#64748B',
    },
    link: {
        // default: '#288d2c',
        // hover: '#455A64',
        // active: '#263238',
        secondary: '#64748B', // Secondary link color
    },
  },
  components: {
    // MuiTextField: {
    //   styleOverrides: {
    //     root: {
    //       '&.Mui-disabled': {
    //         color: 'orange'
    //       }
    //     }
    //   }
    // },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            height: 35,
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiOutlinedInput-input': {
            padding: '8px 14px',
            color: '#333333', // Label color #74ace5(blue) #44a348(Green) #288d2c(green) #007eff(initial blue) 49a76b
            fontWeight: 'bold', // Bold label for better visibility
          },
          
          '& .MuiInputLabel-root': {
            top: '50%',
            transform: 'translate(14px, -12px) scale(1)',
            transition: 'all 0.2s linear',
            marginLeft: '4px',
            pointerEvents: 'none',
            transition: 'all 0.2s linear',
            color: '#837a7f', // Label color
            // fontWeight: 'bold', // Bold label for better visibility
          },
          '& .MuiInputLabel-shrink': {
            top: 0,
            transform: 'translate(14px, -8px) scale(0.70)',
            transition: 'all 0.2s linear',
            maxWidth: '75%',
            color: '#288d2c'
          },
          '& .MuiInputLabel-shrink.Mui-disabled': {
            color:"#a92e2e",
            // color: 'rgba(0, 0, 0, 0.38)', // Optional: Adjust label color for disabled state
          },
          '& .MuiOutlinedInput-root .MuiInputBase-input::placeholder': {
            color: '#B0B0B0', // Global placeholder color
            opacity: 1, // To ensure placeholder color is applied
          },
          '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            // transition: 'all 0.2s linear',
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline' : {
            borderColor: '#288d2c',
          },
          '& .MuiInputLabel-outlined.Mui-focused' : {
            color:"#288d2c"
          },
          // .css-1lhszso-MuiFormLabel-root-MuiInputLabel-root.Mui-focused
          // MuiInputLabel-outlined

          // '& .MuiInputLabel-root': {
          //   top: '50%',
          //   transform: 'translateY(-50%) scale(1)',
          //   marginLeft: '4px',
          //   pointerEvents: 'none',
          //   transition: 'color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms',
          //   // transition: 'all 0.2s ease-out, transform 0.2s ease-out',
          // },
          // '& .MuiInputLabel-shrink': {
          //   top: 0,
          //   transform: 'translate(9px, -9px) scale(0.75)',
          //   transition: 'color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms',
          //   marginLeft: '4px',
          // },
          // '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          //   borderColor: 'rgba(0, 0, 0, 0.87)',
          // },
          // '& .MuiOutlinedInput-notchedOutline': {
          //   // transition: 'border-color 0.2s ease-out, border-width 0.2s ease-out',
          // },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.MuiButton-containedPrimary': {
            backgroundColor: '#288d2c',
            color: '#FFFFFF',
            fontFamily: 'Inter',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '0em',
            padding:'12px'
          },
          '&.Mui-disabled': {
            backgroundColor: '#64748B', // Default disabled color
          }
        },
      },
    },
    MuiLink: {
        styleOverrides: {
          root: {
            color: '#288d2c',
            textDecoration: 'none'
          },
          secondary: {
            color: '#64748B', // Secondary link color
            textDecoration: 'none'
          },
        },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: '#d3d3d3', // Default disabled color
          },
          '&.Mui-disabled.Mui-checked': {
            color: 'black !important', // Black when checked and disabled
          },
        },
        colorPrimary: {
          '&.Mui-checked': {
            color: '#288d2c', // Black when checked and enabled (overrides primary color)
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: 'black', // Default label color (no disabled state)
        },
        root: {
          '&.Mui-disabled .MuiFormControlLabel-label': {
            color: '#64748B', // Default disabled label color
          },
          '&.Mui-disabled .MuiCheckbox-root.Mui-checked + .MuiFormControlLabel-label': {
            color: '#a92e2e', // Red label when checked and disabled
          },
        },
      },
    },
  },
});

export default theme;